import React, { useContext, useEffect, useState } from 'react';
import DateRangePickerComponent from '../../../../components/DaterangePicker';
import { Col, Row } from 'reactstrap';
import { format, startOfMonth } from "date-fns";
import Cookies from "js-cookie";
import { PostData } from '../../../../services/FetchData';
import { buildReportRequestPayload, getActiveWebsiteId } from '../../../../utils/reportUtils';
import { toast } from 'react-toastify';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import { ProductContext } from '../../../../store';
import ReportHeader from '../../../../components/Search/ReportHeader';

const RevenueImpact = () => {
	const [pageLoader, setPageLoader] = useState(true),
		[currencyLoader, setCurrencyLoader] = useState(true),
		[summaryData, setSummaryData] = useState({}),
		[usersImpactData, setUsersImpactData] = useState([]),
		[sessionsImpactData, setSessionsImpactData] = useState([]),
		[shopCurrency, setShopCurrency] = useState("USD"),
		{currentWebsiteId, websitePlatform, websiteLoader, dateRange, setDateRange} = useContext(ProductContext)

	useEffect(() => {
		if (getActiveWebsiteId(currentWebsiteId) && websitePlatform !== "") {
			getRevenueImpact()
			getShopCurrency()
		}
	}, [dateRange, currentWebsiteId, websitePlatform])

	const formPriceText = (price) => {
		let priceAmt = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: shopCurrency,
		}).format(price);
		return priceAmt
	}

	const getShopCurrency = async () => {
		setCurrencyLoader(true)
		let url = "api/v1/admin/bigcommerce/getShopCurrency"
		if(websitePlatform === "shopify") {
			url = "api/v1/admin/shopify/getShopCurrency"
		}else if( websitePlatform === "woocommerce" ){
			url = "api/v1/admin/woocommerce/getShopCurrency"
		}
		PostData("ms3", url, { websiteId: getActiveWebsiteId(currentWebsiteId) })
			.then(response => {
				if (response && response.status === "success") {
					if( websitePlatform === "woocommerce" ){
						setShopCurrency(response.data.shopCurrency)
					}else{
						setShopCurrency(response.data.currency)
					}
				}
			})
			.catch(() => {
				// ignore, just ensure loader clears
			})
			.finally(() => {
				setCurrencyLoader(false)
			})
	}

	const getRevenueImpact = () => {
		setPageLoader(true)
		const data = buildReportRequestPayload(currentWebsiteId, dateRange);
		if (!data) {
			setPageLoader(false);
			return;
		}
		PostData("ms1", "api/v1/analytics/getRevenueImpactReportV3", data).then(response => {
			if (response !== "Invalid" && response !== "undefined") {
				if (response.status === "success") {
					setUsersImpactData(response.data.usersImpact ?? [])
					setSessionsImpactData(response.data.sessionsImpact ?? [])
					setSummaryData(response.data.summary ?? {})
				} else if (response.status === "failure") {
					toast.error(response.message)
				} else {
					toast.error(response.message.message)
				}
			}
			setPageLoader(false)
		})
	}

	// const usersImpactData = [
	// 	{
	// 		label: 'Search / Auto-Complete users',
	// 		uniqueUsers: '1,691 (10.76%)',
	// 		revenues: '$18,013.05',
	// 		userValue: '$10.65',
	// 		productPurchases: '76',
	// 		avgPurchasePrice: '$237.01',
	// 		conversions: '42',
	// 		conversionRate: '2.48%'
	// 	},
	// 	{
	// 		label: 'Smart Collections users',
	// 		uniqueUsers: '6,065 (38.6%)',
	// 		revenues: '$6,919.81',
	// 		userValue: '$1.14',
	// 		productPurchases: '24',
	// 		avgPurchasePrice: '$288.33',
	// 		conversions: '16',
	// 		conversionRate: '0.26%'
	// 	},
	// 	{
	// 		label: 'Other users',
	// 		uniqueUsers: '7,958 (50.64%)',
	// 		revenues: '$4,752.50',
	// 		userValue: '$0.60',
	// 		productPurchases: '25',
	// 		avgPurchasePrice: '$190.10',
	// 		conversions: '18',
	// 		conversionRate: '0.23%'
	// 	},
	// 	{
	// 		label: 'Total',
	// 		uniqueUsers: '15,714',
	// 		revenues: '$29,685.36',
	// 		userValue: '$1.89',
	// 		productPurchases: '125',
	// 		avgPurchasePrice: '$237.48',
	// 		conversions: '76',
	// 		conversionRate: '0.48%',
	// 		total: true
	// 	}
	// ];

	// const sessionsImpactData = [
	// 	{
	// 		label: 'Search / Auto-Complete sessions',
	// 		sessions: '2,094 (10.64%)',
	// 		revenues: '$15,049.47',
	// 		sessionValue: '$7.19',
	// 		productPurchases: '69',
	// 		avgPurchasePrice: '$218.11',
	// 		conversions: '36',
	// 		conversionRate: '1.72%'
	// 	},
	// 	{
	// 		label: 'Smart Collections sessions',
	// 		sessions: '7,252 (36.86%)',
	// 		revenues: '$9,602.94',
	// 		sessionValue: '$1.32',
	// 		productPurchases: '29',
	// 		avgPurchasePrice: '$331.14',
	// 		conversions: '20',
	// 		conversionRate: '0.28%'
	// 	},
	// 	{
	// 		label: 'Other sessions',
	// 		sessions: '10,328 (52.5%)',
	// 		revenues: '$5,032.95',
	// 		sessionValue: '$0.49',
	// 		productPurchases: '27',
	// 		avgPurchasePrice: '$186.41',
	// 		conversions: '20',
	// 		conversionRate: '0.19%'
	// 	},
	// 	{
	// 		label: 'Total',
	// 		sessions: '19,674',
	// 		revenues: '$29,685.36',
	// 		sessionValue: '$1.51',
	// 		productPurchases: '125',
	// 		avgPurchasePrice: '$237.48',
	// 		conversions: '76',
	// 		conversionRate: '0.39%',
	// 		total: true
	// 	}
	// ];

	return (
		<>
			{/* <div>
				<Row className="mt-3 align-items-center justify-content-between">
					<Col xs="auto">
						<h2>Revenue Impact</h2>
					</Col>
					<Col xs="auto">
						<DateRangePickerComponent
							dateRange={dateRange}
							minDate={new Date('2025-07-14')}
							onSelect={(range) => setDateRange(range)}
						/>
					</Col>
				</Row>
			</div> */}
			{(pageLoader || currencyLoader )?
				<DetailSkeleton />
			:
				<div>
					<ReportHeader range={dateRange} onDateChange={(range) => setDateRange(range)} />
					<Row className="mt-5 revenueCardRow">
						<Col className="revenueCard">
							<div className="revenueCardTitle">Revenue</div>
							<div className="revenueCardContent">
								<div>
									<div className="revenuePrimaryValue">{formPriceText(summaryData.revenues?.search ?? 0)}</div>
									<div className="revenueCardLabel">Search / Autocomplete</div>
								</div>
								<div>
									<div className="revenueSecondaryValue">{formPriceText(summaryData.revenues?.collection ?? 0)}</div>
									<div className="revenueCardLabel">Smart Collections</div>
								</div>
								<div>
									<div className="revenueTertiaryValue">{formPriceText(summaryData.revenues?.other ?? 0)}</div>
									<div className="revenueCardLabel">Non CB</div>
								</div>
							</div>
						</Col>

						<Col className="revenueCard">
							<div className="revenueCardTitle">Conversion Rate</div>
							<div className="revenueCardContent">
								<div>
									<div className="revenuePrimaryValue">{summaryData.conversionRate?.search ?? '0%'}</div>
									<div className="revenueCardLabel">Search / Autocomplete</div>
								</div>
								<div>
									<div className="revenueSecondaryValue">{summaryData.conversionRate?.collection ?? '0%'}</div>
									<div className="revenueCardLabel">Smart Collections</div>
								</div>
								<div>
									<div className="revenueTertiaryValue">{summaryData.conversionRate?.other ?? '0%'}</div>
									<div className="revenueCardLabel">Non CB</div>
								</div>
							</div>
						</Col>
					</Row>

					<Row className="mt-4">
						<Col>
							<h2 className="revenueTableHeading">Users Impact</h2>
							<div className="revenueTableWrapper">
								<table className="table revenueTable">
									<thead>
										<tr className="revenueTableHeader">
											<th> </th>
											<th>Unique Users</th>
											<th>Revenues</th>
											<th>User Value</th>
											<th>Product Purchases</th>
											<th>Average Purchase Price</th>
											<th>Conversions</th>
											<th>Conversion Rate</th>
										</tr>
									</thead>
									<tbody>
										{(Array.isArray(usersImpactData) ? usersImpactData : []).map((row) => (
											<tr
												key={row.group}
												className={row.total ? 'revenueTableRowTotal' : 'revenueTableRow'}
											>
												<td>{row.group}</td>
												<td>{row.uniqueUsers}</td>
												<td>{formPriceText(row.revenues)}</td>
												<td>{formPriceText(row.userValue)}</td>
												<td>{row.productPurchases}</td>
												<td>{formPriceText(row.avgPurchasePrice)}</td>
												<td>{row.conversions}</td>
												<td>{row.conversionRate}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</Col>
					</Row>
					{/* Sessions Impact Table */}
					<Row className="mt-4">
						<Col>
							<h2 className="revenueTableHeading">Sessions Impact</h2>
							<div className="revenueTableWrapper">
								<table className="table revenueTable">
									<thead>
										<tr className="revenueTableHeader">
											<th> </th>
											<th>Sessions</th>
											<th>Revenues</th>
											<th>Session Value</th>
											<th>Product Purchases</th>
											<th>Average Purchase Price</th>
											<th>Conversions</th>
											<th>Conversion Rate</th>
										</tr>
									</thead>
									<tbody>
										{(Array.isArray(sessionsImpactData) ? sessionsImpactData : []).map((row) => (
											<tr
												key={row.group}
												className={row.total ? 'revenueTableRowTotal' : 'revenueTableRow'}
											>
												<td>{row.group}</td>
												<td>{row.sessions}</td>
												<td>{formPriceText(row.revenues)}</td>
												<td>{formPriceText(row.sessionValue)}</td>
												<td>{row.productPurchases}</td>
												<td>{formPriceText(row.avgPurchasePrice)}</td>
												<td>{row.conversions}</td>
												<td>{row.conversionRate}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</Col>
					</Row>
				</div>
			}
		</>
	);
};

export default RevenueImpact;


